import React, { ReactNode } from 'react';
import styles from './styles/styles.module.css';
import Sidebar from '../Sidebar/Sidebar';
import Header from './Header';
import BottomControllBar from '../BottomControllBar/BottomControllBar';

interface LayoutProps {
  children: ReactNode;
  displayOff?: boolean;
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  displayOff = false,
}) => {
  return (
    <div className={styles.wrapper}>
      <Sidebar />
      <div className={styles.displayContainer}>
        <Header />

        {displayOff ? (
          <>{children}</>
        ) : (
          <div className={styles.display}>{children}</div>
        )}
      </div>
      <BottomControllBar />
    </div>
  );
};
